import { defineStore } from "pinia";
const useLayoutStore = defineStore("layoutStore", {
  state: () => ({})
});
export { useLayoutStore };
